<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <!-- 主体 -->
        <div :class="css.container" class="pt-[120px] mx-auto w-[1136px]" v-loading="loading">
            <!-- * 模型名称 -->
            <h1 class="text-center font-bold text-emphas text-[40px] leading-[72px]">{{ $t("SequenceProcessor") }}</h1>
            <!-- * 模型介绍 -->
            <ui-modal ref="info" height="auto" spacing="32px 56px 40px">
                <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("ModelIntroduction") }}</div>
                <div class="mt-[16px]">
                    <p>{{ $t("SequenceProcessorDescript") }}</p>
                </div>
            </ui-modal>

            <!-- * 输入界面 -->
            <div class="mt-[40px] bg-color7 px-[48px] pt-[24px] pb-[40px] flex">
                <div class="mr-[16px]">
                    <div class="mb-[8px] last:mb-0 font-bold text-emphas">{{ $t("TaskType") }}:</div>
                    <div v-for="value in options.tasks">
                        <h2
                            :class="[css.type, value.value == excute.value && css.active]"
                            class="font-normal w-[202px] py-[8px] px-[20px] border border-solid border-uicolor4 rounded-[4px] bg-white mb-[12px] cursor-pointer"
                            @click="methods.switch(value)">
                            {{ value.label }}
                        </h2>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-[8px]">
                        <div class="font-bold text-emphas">{{ $t("InputBox") }}</div>
                        <!-- * 模型介绍 -->
                        <div class="flex items-center justify-center">
                            <h2
                                class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main"
                                @click="info?.openModal()">
                                {{ $t("ModelIntroduction") }}
                            </h2>
                            <div class="w-[1px] h-[12px] mx-[16px] bg-emphas"></div>
                            <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="methods.next">
                                {{ $t("VideoTutorial") }}
                            </h2>
                            <div class="w-[1px] h-[12px] mx-[16px] bg-emphas"></div>
                            <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="methods.image">
                                {{ $t("TextTutorial") }}
                            </h2>
                        </div>
                    </div>
                    <ui-textarea
                        v-model="sequence"
                        class="h-[280px]"
                        :class="css.textarea"
                        placeholder="Please enter a DNA or RNA sequence."
                        v-on="ons.textarea">
                    </ui-textarea>
                    <div class="mt-[16px]" v-show="has_ambiguity_codes">{{ $t("SequencesContainingAmbiguityCodes") }}</div>
                    <div class="flex mt-[24px]">
                        <ui-button :width="112" size="middle" :disabled="!sequence.length" @click="methods.submit">{{ $t("Submit") }}</ui-button>
                        <ui-button :width="112" size="middle" class="ml-[16px]" :class="css_button.cancel" :disabled="!sequence.length">
                            {{ $t("Clear") }}
                        </ui-button>
                    </div>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiModal, UiButton, UiTextarea } from "various-ui";

//* 组件属性
import { useComposable } from "./src/composable";

//* 样式
import css_button from "@/assets/style/src/button.module.less";
import css from "./index.module.less";

//* 组合函数
const { ons, refs, nodes, methods, options } = useComposable();
const { loading, excute, sequence, has_ambiguity_codes } = refs;
const { info } = nodes;
</script>
